import Marquee from "react-fast-marquee";
import { Zap } from "lucide-react";

const phrases = [
  "Fully insured",
  "Domestic & commercial",
  "Basildon & surrounding Essex",
  "Clear, upfront quotes",
  "Tidy, respectful work",
  "Homes, landlords & businesses",
];

const TrustMarquee = () => (
  <div
    data-testid="trust-marquee"
    className="bg-slate-100 border-y border-slate-200 py-5 overflow-hidden"
    aria-hidden="true"
  >
    <Marquee speed={30} gradient={false}>
      {phrases.map((p) => (
        <span
          key={p}
          className="mx-8 flex items-center gap-8 text-sm font-bold uppercase tracking-[0.2em] text-slate-500"
        >
          {p}
          <Zap className="w-4 h-4 text-amber-500" fill="currentColor" />
        </span>
      ))}
    </Marquee>
  </div>
);

export default TrustMarquee;
